import { Popover } from "radix-ui";
import Button from "@/components/bricks/button/Button";
import { useCallback, useState } from "react";
import { Input } from "rsuite";
import { Editor } from "@tiptap/react";
import FormatLinkIcon from "../icons/FormatLinkIcon";

const LinkDropdown = (props: { editor: Editor }) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");
  const { editor } = props;

  const toggleLink = useCallback(
    (url) => {
      if (url === null) {
        return;
      }
      if (url === "") {
        editor.chain().focus().extendMarkRange("link").unsetLink().run();
        return;
      }
      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url, target: "_blank" })
        .run();
    },
    [editor],
  );
  return (
    <Popover.Root modal open={open} onOpenChange={(open) => setOpen(open)}>
      <Popover.Trigger className="c-dropdown-menu-trigger" asChild={true}>
        <Button
          transparent
          type="button"
          color="secondary"
          className={`btn--icon rounded${
            editor.isActive("link") ? " text-dark" : ""
          }`}
          aria-label="Indsæt hyperlink"
        >
          <FormatLinkIcon />
        </Button>
      </Popover.Trigger>
      <Popover.Anchor />
      <Popover.Portal>
        <Popover.Content className="c-dropdown-menu-content" alignOffset={-50}>
          <Popover.Arrow className="c-dropdown-menu-arrow" />
          <div className="d-flex gap-3 p-2">
            <label className="form-label sr-only" htmlFor="link-input">
              Link
            </label>
            <Input
              className="form-control"
              id="link-input"
              placeholder="www.example.dk"
              onChange={(url) => setUrl(url)}
              value={url}
            />
            <Button
              type="button"
              onClick={() => {
                toggleLink(url);
                setOpen(false);
              }}
            >
              Indsæt
            </Button>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default LinkDropdown;
